import React from 'react';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { GeneralProductItem, useGeneralProductItem } from '@sharedComponents/Products';
import { GridDivider } from '@sharedComponents/Separators';
import { ReactFCV } from '@types';
import { DIVIDER_COLOR, DIVIDER_HEIGHT } from '@utils/constants';

import { useAdaptedProductItem } from './hooks/useAdaptedProductItem';
import { useDiscoveryBoxProduct } from './hooks/useDiscoveryBoxProduct';
import { CartProductRow, StyledProductWrapper } from './styled';

export const CartProductsWrapper: ReactFCV<IBasicStyledProps> = ({ ...rest }) => {
  const discoveryBoxes = useDiscoveryBoxProduct();
  const adaptedProducts = useAdaptedProductItem();
  const renderProducts = useGeneralProductItem([...adaptedProducts, ...discoveryBoxes]);

  return (
    <StyledProductWrapper {...rest}>
      <CartProductRow>
        {renderProducts.map(
          ({
            key,
            generalProductItem,
            buttonProps,
            imageProps,
            pricePerUnitProps,
            quantityProps,
            textProps,
            totalPrice,
          }) => (
            <React.Fragment key={key}>
              {!textProps.isEngraving && <GridDivider color={DIVIDER_COLOR} height={DIVIDER_HEIGHT} />}
              <GeneralProductItem {...generalProductItem}>
                <GeneralProductItem.Image {...imageProps} />
                <GeneralProductItem.Text {...textProps} />
                <GeneralProductItem.PricePerUnit {...pricePerUnitProps} />
                <GeneralProductItem.Quantity {...quantityProps} />
                <GeneralProductItem.TotalPrice {...totalPrice} />
                <GeneralProductItem.Button {...buttonProps} />
              </GeneralProductItem>
            </React.Fragment>
          ),
        )}
      </CartProductRow>
    </StyledProductWrapper>
  );
};
